import { array, struct } from 'io-ts/Decoder';

import { Id as MaterialTemplateId } from '../../../../whole-house/material-template/Id';
export const Request = struct({
	materialTemplateIds: array(MaterialTemplateId),
});
